import React from 'react';

interface ColouredStyledButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
}

const ColouredStyledButton: React.FC<ColouredStyledButtonProps> = ({ onClick, children, className = '' }) => {
  return (
    <button
      className={`w-1/2 px-4 py-2 border-2 border-black rounded-lg 
                  transform transition-transform duration-150 ease-in-out
                  hover:-translate-y-0.5 hover:translate-x-0.5
                  shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]
                  hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]
                  active:shadow-none active:translate-x-1 active:translate-y-1
                  bg-gradient-to-r from-[#ffe0e7] to-[#f3e0ff] ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default ColouredStyledButton; 